<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />{{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br>
            {{ userStore.user.ssn }} | {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
        </p>
        <p>
            Subject: Final Request To Remove Unauthorized Inquiries
        </p>

        <p class="letter-content">
            This is my last and final letter to your non compliant company before I file suit against all parties 
            involved. FYI, it is a crime to threaten suit with no intention of actually filing suit, so be advised…I 
            have every intention of following through with this to protect my rights as a consumer. 
        </p>
        <p class="letter-content">
            I have sent your company many letters requesting that you investigate a list of inquiries that I 
            believe are reporting incorrectly. Not responding to my requests is a violation of the Fair Credit 
            Reporting Act and will not be tolerated. In case you would like to settle this matter between you 
            and I, rather than me filing suit against your company, I will once again list the inquiries in 
            question so that you may do as you are governed by the FCRA. Please investigate the following: 
        </p>
        <h3>Inquiries in Dispute:</h3>
        <p v-for="(inquiry, iteration) in reportStore.getInquiries(1, creditBureau.name)">
            {{ iteration+1 }}. {{ inquiry.creditor_name }}
            <br />
            <strong>
                Delete this Inquiry for fraudulent reporting becuase 
                <template v-if="inquiry.reason">
                    {{ inquiry.reason }}
                </template>
                The Inquiry was reported on {{ inquiry.date_of_inquiry }}
            </strong>
            
            <br />
        </p>
        <p class="letter-content">
            I have tried to contact these companies on my own, but I have not been able to get very far. I 
            tried to contact them using the phone numbers that are provided on my credit report. Half of the 
            numbers are not even correct. The companies that I was able to get in touch with do not even 
            have any record of me. How can they have a permissible business purpose to pull my credit, if 
            they have NO record of me? 
        </p>
        <p class="letter-content">
            As I stated, I have already given your company quite enough time to investigate the items in 
            question, but I am willing to give you one more chance. If I do not receive results of your 
            investigation within 15 days of receipt of this letter, I will be forced to file suit against your 
            company. I will also be contacting the Better Business Bureau and the Federal Trade Commission. 
        </p>
        <p>
            Regards
        </p>
        <p style="page-break-after: always;">
            Sincerely,
            <br> <br>
            <template v-if="userStore.user.middle_name">
                {{ userStore.user.firstname }} {{userStore.user.middle_name}} {{ userStore.user.lastname }}
                <br>
            </template>
            <template else>
                Sincerely,
                <br> <br>
                {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            </template>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            originalLetterDate: {
                type: String
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
